import { render, staticRenderFns } from "./GymPassConfirm.vue?vue&type=template&id=124fc1e1"
import script from "./GymPassConfirm.vue?vue&type=script&lang=js"
export * from "./GymPassConfirm.vue?vue&type=script&lang=js"
import style0 from "./GymPassConfirm.vue?vue&type=style&index=0&id=124fc1e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports